/**
 * How long fetched data counts as fresh, shared by every query (see
 * `queryClient.ts`).
 *
 * - `staleTime` is short enough that a page shows what changed elsewhere (a
 *   reply, an accepted match, a new contract) when it is opened again, and
 *   long enough that React Strict Mode's double mount doesn't refetch.
 * - `refetchOnMount: true` refetches stale data when a page mounts again.
 *   It used to be `false`, which kept unread counts, consent states and
 *   contracts from the first visit for the whole session.
 */
export const QUERY_FRESHNESS = {
  staleTime: 30_000,
  refetchOnMount: true,
} as const;
